/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { 
    Card, 
    Button, 
    Row, 
    Col, 
    CardBody, 
    CardHeader,
    Form, 
    Badge,
    FormGroup, 
    Container,
    Label, 
    Input ,
    DropdownItem,DropdownMenu, UncontrolledDropdown, DropdownToggle
} from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import SweetAlert from "react-bootstrap-sweetalert";
import Halaman404 from 'views/404';

const HistoripenjualanProdukPagination = () => {
  const [alert, setAlert] = React.useState(null);
  const token = localStorage.token;
  const username = localStorage.username;
  const warehouse = parseInt(localStorage.warehouse);
  const redirectPrefix = `/admin/penjualan/so/penjualan/histori/detail/`;
  const [rowIndex, setRowIndex] = useState(0);
  const [allpenjualanproduk, setAllPenjualanProduk] = useState([]);
  const [status, setStatus] = useState("");
  const [status1, setStatus1] = useState("");
  const [usercode, setUserCode] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerpage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [currentSort, setCurrentSort] = useState("");

  let paginationOption = {
    page: page,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPage: perPage,
    totalSize: totalItem,
    onPageChange: (page) => {
      updateDataTable(page, perPage, currentSort, usercode, status, status1);
    },
    sizePerPageRenderer: () => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                updateDataTable(page, e.target.value, currentSort)
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  }

  const updateDataTable = (page, perPage, sort, usercode,status, status1 ) => {
    getPenawaranSo(page, perPage, sort,usercode, status, status1 );
    setPage(page);
    setPerpage(perPage);
    setRowIndex((page - 1) * perPage);
    setCurrentSort(sort);
    setUserCode(usercode);
    setStatus(status);
    setStatus1(status1)
  }

  const handleTableChange = (type, { sortField, sortOrder }) => {
    if (type === "sort") {
      let sort = `${sortField} ${sortOrder}`
      updateDataTable(page, perPage, sort, usercode, status, status1)
    }
  }

  
  useEffect(() => {
    getPenawaranSo(page, perPage, currentSort);
  }, []);

  // fungsi dari ambil data
  const getPenawaranSo = async (page, perPage, currentSort, user_name = null,pic1_state = null, pic2_state = null) => {
    
    let filter = { 
    //   warehouse_id : warehouse,
      page: page, 
      per_page: perPage,
    };
    if (user_name !== null) {
      filter = Object.assign(filter, { user_name: user_name })
    }
    if (pic1_state !== null) {
        filter = Object.assign(filter, { pic1_state: pic1_state })
    }
    if (pic2_state !== null) {
        filter = Object.assign(filter, { pic2_state: pic2_state })
    }
    const data = filter;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/so-commerce/page`, data, {
        headers,
      })
      .then((data) => {
        setAllPenjualanProduk(data.data.response);
        setPage(data.data.current_page + 1);
        setPerpage(data.data.per_page);
        setTotalItem(data.data.total_item);
      })
      .catch(function (error) {
        setAllPenjualanProduk(error.response.data.response);
      });
  }

  const setGagalAlert = (id) => {
    setAlert(
      <SweetAlert
        danger
        showConfirm
        confirmBtnText="Ok"
        title={id}
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const reset = () => {
    setUserCode("");
    setStatus("");
    setStatus1("");
    updateDataTable(1, perPage, currentSort, "", "", "");
  }

  const formatRupiah = (money) => {
    return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(money);
};

  return (
    <div>
      {alert}
        <SimpleHeader name="Histori" parentName="" />
          <Container className="mt--6" fluid>
          <Row>
            <div className="col">
            <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ textAlign: 'left' }}>
                        <Link className="btn btn-link" to="/admin/penjualan/so/penjualan">
                        <i className="fa fa-arrow-circle-left fa-2x" /> 
                      </Link>
                    </div>
                    {/* <div style={{ textAlign: 'right' }}>
                      <Link className="btn btn-danger" to="/admin/master/mgm/mgm/create">
                      <i className="fas fa-plus" /> Tambah
                      </Link>
                    </div> */}
                  </div>
                </CardHeader>
                <CardBody>
                        <Form>
                          <Row md="12">
                              <Col md="3">
                              <FormGroup>
                                <Label
                                  className="form-control-label"
                                  htmlFor="exampleFormControlSelect3"
                              >User</Label>
                                <Input
                                className="form-control-alternative"
                                  type="text"
                                  placeholder="Masukan Kode User"
                                  value={usercode}
                                  onChange={e => updateDataTable(1, perPage, currentSort, e.target.value, status, status1)}
                                />
                              </FormGroup>
                            </Col>
                            <Col md="3">
                              <FormGroup>
                                <Label
                                  className="form-control-label"
                                  htmlFor="exampleFormControlSelect3"
                              >Status Cabang</Label>
                                <Input
                                className="form-control-alternative"
                                  type="select"
                                  placeholder="Masukan Customer"
                                  value={status}
                                  onChange={e => updateDataTable(1, perPage, currentSort, usercode, e.target.value ,status1)}
                                >
                                    <option value="">Pilih Status</option>
                                    <option value={3}>Proses</option>
                                    <option value={4}>Tolak</option>
                                    <option value={5}>Setuju</option>
                                </Input>
                              </FormGroup>
                            </Col>
                             <Col md="3">
                              <FormGroup>
                                <Label
                                  className="form-control-label"
                                  htmlFor="exampleFormControlSelect3"
                              >Status Barang</Label>
                                <Input
                                className="form-control-alternative"
                                  type="select"
                                  placeholder="Masukan Customer"
                                  value={status1}
                                  onChange={e => updateDataTable(1, perPage, currentSort, usercode, status, e.target.value)}
                                >
                                    <option value="">Pilih Status</option>
                                    <option value={0}>Konfirmasi Pembayaran</option>
                                    <option value={1}>Di Batalkan Customer</option>
                                    <option value={2}>Di Batalkan Cabang</option>
                                    <option value={3}>Dalam Pesanan</option>
                                    <option value={4}>Tiba Di Gudang</option>
                                    <option value={5}>Tiba Di Toko</option>
                                    <option value={6}>Menuju Alamat Pengiriman</option>
                                    <option value={7}>Telah Sampai</option>
                                    <option value={8}>Pengembalian</option>
                                    <option value={9}>Selesai</option>
                                    <option value={10}>Mengalami Kendala</option>
                                </Input>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Button type="button" onClick={reset} color="secondary">Reset</Button>
                            </Col>
                          </Row>
                        </Form>
                        {allpenjualanproduk === null ? (
                        <div>
                          <ToolkitProvider
                                  rowNumber={rowIndex}
                                  data={""}
                                  keyField="id"
                                  columns={[
                                  {
                                    dataField: "no",
                                    text: "#",
                                    sort: true,
                                    page: 1,
                                    formatter: (cell, row, index) => {
                                    let currentRow = ++index;
                                    return currentRow + rowIndex;
                                    },
                                },
                                {
                                    dataField: "",
                                    text: "Tanggal",
                                    sort: true,
                                  },
                                  {
                                    dataField: "",
                                    text: "Kode Transaksi",
                                    sort: true,
                                  },
                                  {
                                    dataField: "",
                                    text: "User",
                                    sort: true,
                                  },
                                  {
                                    dataField: "",
                                    text: "Status",
                                    sort: true,
                                  },
                                  ]}
                              >
                                  {(props) => (
                                  <div className="py-4 table-responsive">
                                      <BootstrapTable
                                      remote
                                      {...props.baseProps}
                                      bootstrap4={true}
                                      bordered={false}
                                      hover={true}
                                      onTableChange={handleTableChange}
                                      />
                                  </div>
                                  )}
                          </ToolkitProvider>
                          <CardHeader>
                              <center><h3>DATA NOT FOUND</h3></center>
                          </CardHeader>
                        </div>
                        ):(
                      <ToolkitProvider
                              rowNumber={rowIndex}
                              data={allpenjualanproduk}
                              keyField="id"
                              columns={[
                              {
                                  dataField: "no",
                                  text: "#",
                                  sort: true,
                                  page: 1,
                                  formatter: (cell, row, index) => {
                                  let currentRow = ++index;
                                  return currentRow + rowIndex;
                                  },
                              },
                              {
                                dataField: "transaction_date",
                                text: "Tanggal",
                                sort: true,
                              },
                              // {
                              //   dataField: "user_code",
                              //   text: "Kode User",
                              //   sort: true,
                              // },
                              {
                                dataField: "code_transaction",
                                text: "Kode Transaksi",
                                sort: true,
                              },
                              {
                                dataField: "user_name",
                                text: "User",
                                sort: true,
                              },
                              {
                                dataField: "pic2_state",
                                text: "Status",
                                sort: true,
                                formatter: (cell, row) => {
                                  return row.pic2_state === 0 ? 
                                      <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Konfirmasi Pembayaran
                                      </Badge> : row.pic2_state === 1 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-warning" />
                                        Di Batalkan Customer
                                      </Badge>:  row.pic2_state === 2 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Di Batalkan Cabang
                                      </Badge> : row.pic2_state === 3 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Dalam Pesanan
                                      </Badge> : row.pic2_state === 4 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Tiba Di Gudang
                                      </Badge> : row.pic2_state === 5 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Tiba Di Toko
                                      </Badge> : row.pic2_state === 6 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Menuju Alamat Pengiriman
                                      </Badge> : row.pic2_state === 7 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Telah Sampai Tujuan
                                      </Badge> : row.pic2_state === 8 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-danger" />
                                        Pengembalian
                                      </Badge> : row.pic2_state === 9 ? <Badge color="" className="badge-dot mr-4">
                                        <i className="bg-success" />
                                        Selesai
                                      </Badge> : 
                                      <Badge color="" className="badge-dot mr-4">
                                      <i className="bg-success" />
                                      Mengalami Kendala
                                    </Badge>;
                                },
                            },
                              {
                                  dataField: "", text: "", formatter: (cell, row, index) => {
                                  return (
                                    <UncontrolledDropdown nav>
                                    <DropdownToggle className="btn btn-danger" color="" tag="a">
                                          Tindakan
                                    </DropdownToggle>
                                    <DropdownMenu center>
                                          <Link  to={redirectPrefix + row.id}
                                            id={"tooltip_" + row.id}>
                                          <DropdownItem>
                                            <i className="fa fa-check-circle"  aria-hidden="true"/> Detail
                                          </DropdownItem>
                                          </Link>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                    )
                                  }
                                },
                              ]}
                          >
                              {(props) => (
                              <div className="py-4 table-responsive">
                                  <BootstrapTable
                                  remote
                                  {...props.baseProps}
                                  bootstrap4={true}
                                  bordered={false}
                                  hover={true}
                                  pagination={paginationFactory({ ...paginationOption })}
                                  onTableChange={handleTableChange}
                                  />
                              </div>
                            )}
                      </ToolkitProvider>
                        )}
                </CardBody>
              </Card>
            </div>
          </Row>
          </Container>
    </div>
  );
}

export default HistoripenjualanProdukPagination;